import React, { forwardRef } from 'react';
import { ListItemIcon as MuiListItemIcon } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!

 Explicit props based on actual usage in the codebase.
**/
export interface ListItemIconProps {
  /** The icon element rendered inside the list item. */
  children?: React.ReactNode;
}

const ListItemIcon = forwardRef<HTMLDivElement, ListItemIconProps>(({ children, ...restProps }, ref) => {
  if (!isEmpty(restProps)) {
    reportErrorInProductionOrThrow(
      `Unexpected props passed to ListItemIcon: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the ListItemIconProps interface and to the component's signature.`,
      true
    );
  }

  return (
    <MuiListItemIcon ref={ref} {...restProps}>
      {children}
    </MuiListItemIcon>
  );
});

ListItemIcon.displayName = 'ListItemIcon';

export default ListItemIcon;
